import { z } from 'zod'
import typeguard from '../typeguard'

import { imageSchema } from '../dbTypes/brand'


const brandSchema = z.object({
  id: z.number(),
  titel: z.string(),
  metaTitle: z.string(),
  metaDescription: z.string().optional(),
  metaKeywords: z.string().optional(),
  path: z.string(),
  logos: z.object({
    color: imageSchema.omit({ orig: true }).optional(),
    mono: imageSchema.omit({ orig: true }).optional(),
  }).optional(),
})
export type tBrand = z.infer<typeof brandSchema>
export const isBrand = typeguard<tBrand>(brandSchema)


const brandsSchema = z.array(brandSchema)
export type tBrands = z.infer<typeof brandsSchema>
export const isBrands = typeguard<tBrands>(brandsSchema)

/* ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
/* Responses */

const brandsResponseSchema = z.object({
  count: z.number(),
  brands: brandsSchema,
})
export type brandsResponse = z.infer<typeof brandsResponseSchema>
export const isBrandsResponse = typeguard<brandsResponse>(brandsResponseSchema)

/* ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
